import { Flex } from '@homebotapp/hb-react-component-catalog'

export const StepContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex direction='column' width='100%' flex={1} justifyContent='space-between'>
      {children}
    </Flex>
  )
}
